/* eslint-disable */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import ProgressButton from "react-progress-button";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: "#1976D2",
    marginLeft: 0,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "white",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

const ChecksModal = ({
  setOpen,
  open,
  handleDownloadPdf,
  setPdfDetails,
  pdfDetails,
}) => {
  const handleClose = () => {
    setOpen(false);
  };
  const inputStyle = {
    display: "block",
    padding: "1.4rem 0.75rem",
    width: "100%",
    fontSize: "0.8rem",
    lineHeight: 1.25,
    color: "#55595c",
    backgroundColor: "#fff",
    backgroundImage: "none",
    backgroundClip: "padding-box",
    borderTop: "0",
    borderRight: "0",
    borderBottom: "1px solid #eee",
    borderLeft: "0",
    borderRadius: "3px",
    transition: "all 0.25s cubic-bezier(0.4, 0, 1, 1)",
  };

  return (
    <div>
      <form>
        <Dialog
          onClose={(e, reason) => {
            if (reason !== "backdropClick") {
              handleClose();
            }
          }}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
            style={{ paddingLeft: "20px", color: "white" }}
          >
            Download PDF
          </DialogTitle>
          <DialogContent dividers>
            <div className="customInputs">
              <input
                placeholder="Holder name"
                style={inputStyle}
                name="holderName"
                type="text"
                onChange={(e) =>
                  setPdfDetails({ ...pdfDetails, holderName: e.target.value })
                }
                value={pdfDetails.holderName}
              />
              <input
                placeholder="Holder name"
                style={inputStyle}
                name="holderName"
                type="date"
                onChange={(e) =>
                  setPdfDetails({ ...pdfDetails, deliveryDate: e.target.value })
                }
                value={pdfDetails.deliveryDate}
              />

              <input
                placeholder="Depositor name"
                style={inputStyle}
                name="depositorName"
                type="text"
                onChange={(e) =>
                  setPdfDetails({
                    ...pdfDetails,
                    depositorName: e.target.value,
                  })
                }
                value={pdfDetails.depositorName}
              />

              <input
                placeholder="CIN"
                style={inputStyle}
                name="cin"
                type="text"
                onChange={(e) =>
                  setPdfDetails({
                    ...pdfDetails,
                    cin: e.target.value,
                  })
                }
                value={pdfDetails.cin}
              />
              <input
                placeholder="Delivery ID"
                style={inputStyle}
                name="deliveryID"
                type="text"
                onChange={(e) =>
                  setPdfDetails({
                    ...pdfDetails,
                    deliveryID: e.target.value,
                  })
                }
                value={pdfDetails.deliveryID}
              />
            </div>
            <div>
              <ProgressButton onClick={() => handleDownloadPdf()}>
                Download PDF
              </ProgressButton>
            </div>
          </DialogContent>
        </Dialog>
      </form>
    </div>
  );
};

export default ChecksModal;
